import { useProperties } from './useProperties';
export const useProperty = propertyName => {
  const properties = useProperties();
  if (propertyName === undefined || propertyName === null) {
    return undefined;
  }
  return properties && properties.get(propertyName);
};